import Moment from "moment";
import { store } from "../../../../../config/store";
import {
  GetDenunciasApi,
  CreateDraftComplains,
  GetDraftComplains,
  GetDraftComplainsById,
  UpdateDraftComplaint,
  DeleteDraftComplaint,
  GetDenunciasPendientesTrabajador,
  GetValidacionTrabajadorEmpresa,
  CreateNewComplaint,
  GetDenunciaPDF,
} from "../../../../../services/denunciasApi";
import { openCloseToast, getLists } from "../../../../Global/actions";
import { getUserInfo } from "../../../../../services/misDatosApi";
import validaciones from "../../../../../helpers/validaciones";
import { filterData } from "../../../../../helpers/filterHelper";
import {
  getCompanyDenunciaData,
  GetCompanyValidOffices,
  getCompanyDetails,
} from "../../../../../services/datosEmpresa";
import trace from "../../../../../helpers/trace";
import { showFile } from "../../../../Pdf/actions";
import { filterType } from "../../../../../helpers/filterHelper";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import { getParametersListByName } from "../../../../../services/listasApi";
import { GetSiniestroDocumentsApi } from "../../../../../services/DocumentosApi";
import { doOpenDocument } from "../../../Documentos/actions";

export const loading = (isLoading) => ({
  type: "LOADING_DENUNCIAS_EMPRESA",
  isLoading,
});

export const nextStep = () => ({
  type: "NEXT_STEP_DENUNCIA",
});

export const lastStep = () => ({
  type: "LAST_STEP_DENUNCIA",
});

export const setStep = (step) => ({
  type: "SET_STEP_DENUNCIA",
  step,
});

export const resetDenunciasEmpresas = () => ({
  type: "RESET_DENUNCIAS_EMPRESA",
});

export const setDenunciasEmpresa = (listaDenuncias, total) => ({
  type: "SET_DENUNCIAS_EMPRESA",
  listaDenuncias,
  total,
});
export const setDenunciasFiltradaEmpresa = (listaDenunciasFiltrada) => ({
  type: "SET_DENUNCIAS_EMPRESA_FILTRADA",
  listaDenunciasFiltrada,
});

export const setStateAfterDeleteDraft = (
  listaDenuncias,
  listaDenunciasFiltrada,
  showHideForm
) => ({
  type: "SET_STATE_AFTER_DELETE_DRAFT",
  listaDenuncias,
  listaDenunciasFiltrada,
  showHideForm,
});

export const setSortDenunciasByFechaDenuncia = (sort) => ({
  type: "SET_SORT_DENUNCIAS_BY_FECHA_DENUNCIA",
  sort,
});

export const setDenunciasFilter = (filtros) => ({
  type: "SET_DENUNCIAS_FILTER",
  filtros,
});

export const setShowHideForm = (showHideForm) => ({
  type: "SET_SHOWHIDE_FORM_DENUNCIA",
  showHideForm,
});

export const setDataNewComplain = (jsonData) => ({
  type: "SET_DATA_NEW_COMPLAIN",
  jsonData,
});

export const setDataCompanySelected = (company) => ({
  type: "SET_DATA_COMPANY_SELECTED",
  company,
});

export const setDraft = (jsonData) => ({
  type: "SET_DRAFT_DENUNCIA",
  jsonData,
});
export const setCleanDataComplain = () => ({
  type: "SET_CLEAN_DATA_COMPLAIN",
});

export const openCloseModalBorrador = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_BORRADOR_DENUNCIA",
  isOpen,
});

export const editingDraft = (editing) => ({
  type: "EDITING_DRAFT_DENUNCIA",
  editing,
});

export const setDataTrabajador = (data) => ({
  type: "SET_DATA_TRABAJADOR_DENUNCIA",
  data,
});

export const updateDataGridDenuncias = (update) => ({
  type: "UPDATE_DATA_GRID_DENUNCIAS",
  update,
});

export const setPendingComplaints = (complaints) => ({
  type: "SET_PENDING_COMPLAINTS",
  complaints,
});

export const disableNewComplaintButton = (disable) => ({
  type: "DISABLE_NEW_COMPLAINT_BUTTON",
  disable,
});

export const openCloseModalContinue = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_CONTINUE",
  isOpen,
});

export const openCloseModalDelete = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_DELETE",
  isOpen,
});

export const setTipoDenuncia = (tipo) => ({
  type: "SET_TIPO_DENUNCIA",
  tipo,
});

export const setIsDownloadExcel = (isDownloadLoading) => ({
  type: "LOADING_DENUNCIAS_DOWNLOAD_EXCEL",
  isDownloadLoading,
});

export const setCiudadesComunasSiniestro = (ciudades, comunas) => ({
  type: "SET_CIUDADES_COMUNAS_SINIESTRO",
  ciudades,
  comunas,
});

export const setCiudadesComunas = (ciudades, comunas) => ({
  type: "SET_CIUDADES_COMUNAS",
  ciudades,
  comunas,
});

export const setCodigoArea = (codigo) => ({
  type: "SET_CODIGO_AREA",
  codigo,
});

export const setIdComplaint = (idComplaint) => ({
  type: "SET_ID_COMPLAINT",
  idComplaint,
});

export const setCodigoAreaAll = (codigo) => ({
  type: "SET_CODIGO_AREA_ALL",
  codigo,
});

export const setMainFiltersDenuncias = (mainFilters) => ({
  type: "SET_MAIN_FILTERS_DENUNCIAS",
  mainFilters,
});
export const setFilterTipoSiniestros = (filtroTipoSiniestro) => ({
  type: "SET_FILTER_TIPO_SINIESTROS",
  filtroTipoSiniestro,
});

export const setValidSucursales = (sucursales) => ({
  type: "SET_VALID_SUCURSALES_DENUNCIA",
  sucursales,
});

export const getValidOffices = (companyRut) => async (dispatch) => {
  try {
    const rutCompany = localStorage.getItem('rutEnterprise') ?? companyRut;
    const request = await GetCompanyValidOffices(rutCompany);

    if (request.status === 200) {
      const sucursales = await request.json();

      if (Array.isArray(sucursales)) {
        const list = sucursales.sort((a, b) =>
          ("" + a.Direccion).localeCompare(b.Direccion)
        );
        dispatch(setValidSucursales(list));
      }
    }
  } catch (e) {
    trace.error("getCompanyValidOffices", e);
  }
};

export const getCompanyDetailData = (companyRut) => async (dispatch) => {
  try {
    const request = await getCompanyDenunciaData(companyRut);
    const compDetails = await getCompanyDetails(companyRut);
    const parameters = await getParametersListByName({
      listaDirecciones: true,
    });

    if (request.status === 200) {
      const result = await request.json();

      let telefono = "";
      if (compDetails.status === 200) {
        const res = await compDetails.json();
        telefono = res.DetalleEmpresa.telefonoContacto;
      }

      let regiones = [];
      if (parameters.status === 200) {
        const lists = await parameters.json();
        if (lists.ListaDirecciones.Success) {
          regiones = lists.ListaDirecciones.ListadoDirecciones;
        }
      }
      const region = regiones.find(
        (r) => r.DescripcionRegion === result.DatosEmpresa.Region
      );
      if (result.Success) {
        const data = {
          RutEmpresa: companyRut,
          NombreRazon: result.DatosEmpresa.RazonSocial,
          // TipoEmpresa: result.DatosEmpresa.TipoEmpresa,
          Actividad: result.DatosEmpresa.ActividadEconomica,
          ActividadPrincipal: result.DatosEmpresa.ActividadEconomicaPrincipal,
          Propiedad: result.DatosEmpresa.PropiedadEmpresa,
          TotalHombres: result.DatosEmpresa.TotalHombre,
          TotalMujeres: result.DatosEmpresa.TotalMujer,
          Ciudad: result.DatosEmpresa.Ciudad,
          Comuna: result.DatosEmpresa.Comuna,
          Region: region ? region.IdRegion : null,
          NumeroCalle: result.DatosEmpresa.NumeroCalle,
          NombreCalle: result.DatosEmpresa.NombreCalle,
          Telefono: telefono,
        };
        dispatch(setDataCompanySelected(data));
      }
    }
  } catch (error) {
    console.error("getCompanyDetailData", error);
  }
};

export const callListMyData = (rutUsuario, lista) => async (dispatch) => {
  await dispatch(getLists(lista));
};

export const doGetComplains = (data, firstLoad = false) => async (dispatch) => {
  const { companyId, sucursalId, userData } = store.getState().global;
  const { selectedTipoDenuncia } = store.getState().denuncias;
  const filtros = {
    RutEmpresa: companyId,
    Pagina: 1,
    RegistrosPorPagina: 100000,
    FechaDenunciaInicio: data.from,
    FechaDenunciaFin: data.to,
    RutUsuario: userData.RUT,
    StatusId: selectedTipoDenuncia.value.value,
  };
  if (validaciones.emptyText(sucursalId)) {
    filtros.idSucursal = sucursalId;
  }
  dispatch(doGetComplaint(filtros, firstLoad));
};

export const doGetComplaint = (filtros, firstLoad) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await GetDenunciasApi(filtros);
    if (request.status === 200) {
      const result = await request.json();
      dispatch(
        setDenunciasEmpresa(
          result.ListaDenuncias.sort(
            (a, b) => new Date(b.FechaDenuncia) - new Date(a.FechaDenuncia)
          ),
          result.TotalDenuncias
        )
      );
      dispatch(doGetDenunciasFilters(result.ListaDenuncias));
      if (firstLoad === true) {
        const currentFilters = [
          {
            column: "EstadoDenuncia",
            value: { text: "Pendiente", value: "Pendiente" },
          },
        ];
        const newData = filterData(result.ListaDenuncias, currentFilters);
        dispatch(
          setDenunciasFiltradaEmpresa(
            newData.sort(
              (a, b) => new Date(b.FechaDenuncia) - new Date(a.FechaDenuncia)
            )
          )
        );
      } else {
        dispatch(
          setDenunciasFiltradaEmpresa(
            result.ListaDenuncias.sort(
              (a, b) => new Date(b.FechaDenuncia) - new Date(a.FechaDenuncia)
            )
          )
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(loading(false));
};

export const doGetDraft = (CompanyId, rutTrabajador) => async (dispatch) => {
  dispatch(loading(true));
  const toast = {};
  try {
    const request = await GetDraftComplains(CompanyId, rutTrabajador);
    if (request.status === 200) {
      let form = {};
      const result = await request.json();

      form = JSON.parse(result.Complaint.JsonData);
      form.Id = result.Complaint.Id;

      dispatch(setDraft(form));
      dispatch(setStep(form.currentStep));
      dispatch(editingDraft(true));
      dispatch(openCloseModalContinue(true));

      // dispatch(setShowHideForm(true));
    }
    if (request.status === 500) {
      toast.isToastOpen = true;
      toast.msgToast = "Error de conexión, intente más tarde";
      toast.typeStyle = "error";
      toast.displayTime = 5000
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const doGetDraftById = (data, showModalContinue = true) => async (
  dispatch
) => {
  dispatch(loading(true));
  const toast = {};
  try {
    const request = await GetDraftComplainsById(data.IdDraft);
    if (request.status === 200) {
      let form = {};
      const result = await request.json();

      form = JSON.parse(result.Complaint.JsonData);
      form.Id = result.Complaint.Id;
      form.IdSiniestro = data.IdSiniestro;

      dispatch(setDraft(form));
      dispatch(setStep(form.currentStep));
      dispatch(editingDraft(true));
      if (showModalContinue) dispatch(openCloseModalContinue(true));

      // dispatch(setShowHideForm(true));
    }
    if (request.status === 500) {
      toast.isToastOpen = true;
      toast.msgToast = "Error de conexión, intente más tarde";
      toast.typeStyle = "error";
      toast.displayTime = 5000
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    trace.error("doGetDraftById", data, error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const doCreateDraft = (Data, showNotification) => async (dispatch) => {
  if (showNotification) dispatch(loading(true));
  const toast = {};
  try {
    const request = await CreateDraftComplains(Data);
    if (request.status === 200) {
      if (showNotification) {
        toast.isToastOpen = true;
        toast.msgToast = "Creación de borrador realizada";
        toast.typeStyle = "success";
        toast.displayTime = 5000
        dispatch(openCloseToast(toast));
        dispatch(setCleanDataComplain());
        dispatch(setShowHideForm(false));
        dispatch(openCloseModalBorrador(false));
        dispatch(updateDataGridDenuncias(true));
      } else {
        const result = await request.json();
        const jsonData = JSON.parse(Data.jsonData);
        jsonData.Id = result.Id;
        dispatch(setDataNewComplain(jsonData));
      }
      dispatch(setIdComplaint(null));
      dispatch(editingDraft(true));

      // TODO: Añadirla a la Lista de Denuncias.
    }
    if (request.status === 500) {
      if (showNotification) {
        toast.isToastOpen = true;
        toast.msgToast = "Error de conexión, intente más tarde";
        toast.typeStyle = "error";
        toast.displayTime = 5000
        dispatch(editingDraft(false));
        dispatch(openCloseToast(toast));
      }
    }
  } catch (error) {
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
  if (showNotification) dispatch(loading(false));
};

export const doUpdateDraft = (Data, showNotification) => async (dispatch) => {
  if (showNotification) dispatch(loading(true));
  try {
    const request = await UpdateDraftComplaint(Data);
    if (request.status === 200) {
      if (showNotification) {
        dispatch(
          openCloseToast({
            isToastOpen: true,
            msgToast: "Borrador actualizado",
            typeStyle: "success",
            displayTime: 5000
          })
        );

        dispatch(setCleanDataComplain());
        dispatch(setShowHideForm(false));
        dispatch(openCloseModalBorrador(false));
      }
    } else if (showNotification) {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error de conexión, intente más tarde",
          typeStyle: "error",
          displayTime: 5000
        })
      );
    }
  } catch (e) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  if (showNotification) dispatch(loading(false));
};

export const doDeleteDraft = (idComplaint, getComplaits) => async (
  dispatch
) => {
  dispatch(loading(true));
  try {
    if (idComplaint) {
      const listaDenuncias = store
        .getState()
        .denuncias.listaDenuncias.filter(
          (item) => item.IdDraft !== idComplaint
        );
      const listaDenunciasFilter = store
        .getState()
        .denuncias.listaDenunciasFiltrada.filter(
          (item) => item.IdDraft !== idComplaint
        );
      const request = await DeleteDraftComplaint(idComplaint);
      if (request.status === 200) {
        dispatch(
          setStateAfterDeleteDraft(listaDenuncias, listaDenunciasFilter, false)
        );
        if (getComplaits) {
          dispatch(loading(true));
          const data = {
            from: formatDateForFilter(Moment().subtract(1, "year")),
            to: formatDateForFilter(Moment()),
          };
          dispatch(doGetComplains(data));
          dispatch(loading(false));
        } else {
          dispatch(
            openCloseToast({
              isToastOpen: true,
              msgToast: "Borrador Eliminado",
              typeStyle: "success",
              displayTime: 5000
            })
          );
        }
      } else {
        dispatch(
          openCloseToast({
            isToastOpen: true,
            msgToast: "Error de conexión, intente más tarde",
            typeStyle: "error",
            displayTime: 5000
          })
        );
      }
    } else {
      dispatch(setCleanDataComplain());
      dispatch(setShowHideForm(false));
      dispatch(openCloseModalBorrador(false));
    }
  } catch (e) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const doCreateComplaints = (jsonData) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const newData = { ...jsonData };

    newData.formInfoDenuncia = {
      ...jsonData.formInfoDenuncia,
      FechaPresentacion: Moment(jsonData.formInfoDenuncia.FechaPresentacion)
        .local()
        .format(),
    };

    newData.formInfoTrabajador = {
      ...jsonData.formInfoTrabajador,
      HoraIngreso: Moment(jsonData.formInfoTrabajador.HoraIngreso)
        .local()
        .format(),
      HoraSalida: Moment(jsonData.formInfoTrabajador.HoraSalida)
        .local()
        .format(),
    };

    if (
      jsonData.formInfoDenuncia.tipoDenuncia.DescripcionTipoDenuncia === "DIAT"
    ) {
      newData.formDatoSiniestro = {
        ...jsonData.formDatoSiniestro,
        FechaHoraAccidente: Moment(
          jsonData.formDatoSiniestro.FechaHoraAccidente
        )
          .local()
          .format(),
        FechaHoraAviso: Moment(jsonData.formDatoSiniestro.FechaHoraAviso)
          .local()
          .format(),
      };
    }

    const request = await CreateNewComplaint(newData);
    if (request.status === 200) {
      dispatch(doDeleteDraft(jsonData.Id, true));
    } else {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error creando la denuncia, intente más tarde",
          typeStyle: "error",
          displayTime: 5000
        })
      );
    }
  } catch (e) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

// Llamo datos del trabajador por rut
export const getWorkerData = (
  showNotifications,
  jsonData,
  workerRut,
  dataActual
) => async (dispatch) => {
  if (showNotifications) dispatch(loading(true));
  const toast = {};
  try {
    if (
      Object.entries(dataActual).length === 0 &&
      dataActual.constructor === Object
    ) {
      const response = await getUserInfo(workerRut);
      const result = await response.json();
      const form = { ...jsonData };

      let data = {
        Rut: validaciones.formatRut(workerRut, {
          showDots: true,
          showHyphen: true,
        }),
        cantEditFirstName: false,
        cantEditLastName: false,
        cantEditMothersName: false,
      };
      if (response.status === 200) {
        if (result.Success) {
          data = {
            ...data,
            FirstName: result.Profile.Name,
            cantEditFirstName:
              result.Profile.Name != null && result.Profile.Name !== "",
            LastName: result.Profile.FatherLastName,
            cantEditLastName:
              result.Profile.FatherLastName != null &&
              result.Profile.FatherLastName !== "",
            MothersName: result.Profile.MotherLastName,
            cantEditMothersName:
              result.Profile.MotherLastName != null &&
              result.Profile.MotherLastName !== "",
          };
        } else if (showNotifications) {
          dispatch(
            openCloseToast({
              isToastOpen: true,
              msgToast: "No se encontró información del usuario",
              typeStyle: "warning",
              displayTime: 5000
            })
          );
        }
        form.formInfoTrabajador = {
          ...data,
          ...jsonData.formInfoTrabajador,
        };
        dispatch(setDataTrabajador(data));
        dispatch(setDataNewComplain(form));
      } else {
        toast.isToastOpen = true;
        toast.msgToast = result.Message;
        toast.typeStyle = "error";
        toast.displayTime = 5000;
        dispatch(openCloseToast(toast));
      }
    }
  } catch (error) {
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  if (showNotifications) dispatch(loading(false));
};

export const getDenunciasPendientes = (
  modalPendientes,
  complaintType,
  fechaPresentacion,
  data
) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await GetDenunciasPendientesTrabajador(data);
    if (request.status === 200) {
      const result = await request.json();
      if (result.Success) {
        modalPendientes();
        dispatch(setPendingComplaints(result.Complaints));
        const any = result.Complaints.filter(
          (item) =>
            item.TipoSiniestro === complaintType &&
            !Moment(fechaPresentacion).isSame(item.FechaSiniestro)
        );

        if (any.length) {
          dispatch(disableNewComplaintButton(true));
        }
      } else {
        dispatch(nextStep());
      }
    }
  } catch (e) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const getDenunciaTrabajadorPendienteEmpresa = (
  modalPendientes,
  jsonData,
  data
) => async (dispatch) => {
  dispatch(loading(true));
  try {
    data.Fecha = Moment(data.Fecha).format("YYYYMMDD");
    const request = await GetDenunciasApi({
      RutEmpresa: data.CompanyRut,
      Pagina: 1,
      RegistrosPorPagina: 100000,
      FechaDenunciaInicio: data.Fecha,
      FechaDenunciaFin: data.Fecha,
      RutUsuario: data.userData.RUT,
    });

    if (request.status === 200) {
      const result = await request.json();
      const denunciasExistentes = result.ListaDenuncias.filter(
        (e) =>
          e.IdSiniestro !== "" &&
          e.TipoDenuncia === data.Tipo &&
          e.IdDraft == null &&
          e.RutTrabajador === data.Rut
      );

      if (denunciasExistentes.length) {
        // existe una denuncia pendiente o enviada por lo que el usuario debe continuar completando esa denuncia
        dispatch(setPendingComplaints(denunciasExistentes));
        dispatch(disableNewComplaintButton(true));
        modalPendientes();
      } else {
        // no existe denuncia pendiente por lo que se pasa al siguiente paso
        dispatch(nextStep());
      }
    }
  } catch (e) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const doGetDenunciasFilters = (ListaDenuncias) => async (dispatch) => {
  try {
    const filtros = [
      {
        column: "FechaSiniestroOrPresentacion",
        name: "Fecha Siniestro",
        type: filterType.date,
        oneYearInterval: true,
        max: new Date(),
      },
    ];

    const mainFilters = [];
    const pivotDenuncias = ListaDenuncias.map((item) => ({
      text: validaciones.capitalizeFirstLetter(item.EstadoDenuncia),
      value: validaciones.capitalizeFirstLetter(item.EstadoDenuncia),
    }));
    const EstadoDenuncia = validaciones.getUnique(pivotDenuncias, "value");
    const pivotipoDenuncias = ListaDenuncias.filter(
      (x) => x.TipoDenuncia !== null
    ).map((item) => ({
      text: validaciones.capitalizeFirstLetter(item.TipoDenuncia),
      value: validaciones.capitalizeFirstLetter(item.TipoDenuncia),
    }));
    const tipoDenuncias = validaciones.getUnique(pivotipoDenuncias, "value");
    const pivotTipoSiniestro = ListaDenuncias.filter(
      (x) => x.TipoSiniestro !== null
    ).map((item) => ({
      text: validaciones.capitalizeFirstLetter(item.TipoSiniestro),
      value: validaciones.capitalizeFirstLetter(item.TipoSiniestro),
    }));
    const tipoSiniestros = validaciones.getUnique(pivotTipoSiniestro, "value");

    EstadoDenuncia.forEach((item) => {
      let Icon = "S";
      switch (item.text) {
        case "Pendiente": {
          Icon = "S";
          break;
        }
        case "Enviada": {
          Icon = "m";
          break;
        }
        default:
          break;
      }

      mainFilters.push({
        Icon,
        name: item.text,
        column: "EstadoDenuncia",
        value: { text: item.text, value: item.text },
      });
    });
    mainFilters.push({
      Icon: "0",
      name: "Todas las Denuncias",
      column: "EstadoDenuncia",
      value: { text: "TODAS", value: "TODAS" },
    });

    filtros.push(
      {
        column: "EstadoDenuncia",
        name: "Estado",
        showName: false,
        values: EstadoDenuncia,
      },
      {
        column: "TipoDenuncia",
        name: "Tipo denuncia",
        showName: false,
        values: tipoDenuncias,
      }
    );
    const filtroTipoSiniestro = [
      {
        column: "TipoSiniestro",
        name: "Tipo siniestro",
        values: tipoSiniestros,
        showName: true,
      },
    ];
    dispatch(setMainFiltersDenuncias(mainFilters));
    dispatch(setDenunciasFilter(filtros));
    dispatch(setFilterTipoSiniestros(filtroTipoSiniestro));
  } catch (e) {
    console.error(e);
  }
};

export const doGetdenunciaPDF = (idSiniestro, idDocumento) => async (
  dispatch
) => {
  try {
    dispatch(loading(true));
    if (idDocumento && idDocumento !== "") {
      let url = "";
      if (idDocumento.length == 32)
        url = `https://api.achs.cl/documentos/alfresco/ObtenerDocumentosCarpeta?Id=${idDocumento}`;
      else
        url = `https://api.achs.cl/documentos/alfresco/ObtenerDocumento/Id=${idDocumento}`;

      dispatch(doOpenDocument(url));
      dispatch(loading(false));
      return;
    }
    // const url = `http://dev.sucursalvirtual.achs.ae21c4a98d384e9182cb.eastus.aksapp.io/documentos/alfresco/document/pdf/document/${idDocumento}`;
    // dispatch(doOpenDocument(url));
    dispatch(loading(false));

    const request = await GetDenunciaPDF(idSiniestro);
    if (request.status === 503) {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast:
            "La imagen no se encuentra disponible. Para mayor información contactarse con nuestro Call Center al 600 600 2247.",
          typeStyle: "warning",
          displayTime: 5000
        })
      );
    } else if (request.status === 200) {
      const doc = await request.blob();
      showFile(doc);
    } else {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error al obtener el PDF, intentelo nuevamente",
          typeStyle: "error",
          displayTime: 5000
        })
      );
    }
  } catch (e) {
    trace.error("doGetdenunciaPDF", e);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error al obtener el PDF, intentelo mas tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const goGetDenuncianteData = (rut) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getUserInfo(rut);
    if (request.status === 200) {
      const result = await request.json();
      const { jsonData } = store.getState().denuncias;
      dispatch(
        setDataNewComplain({
          ...jsonData,
          formDenunciante: {
            FirstName: result.Profile.Name,
            cantEditFirstName:
              result.Profile.Name != null && result.Profile.Name !== "",
            LastName: result.Profile.FatherLastName,
            cantEditLastName:
              result.Profile.FatherLastName != null &&
              result.Profile.FatherLastName !== "",
            MothersName: result.Profile.MotherLastName,
            cantEditMothersName:
              result.Profile.MotherLastName != null &&
              result.Profile.MotherLastName !== "",
            Rut: validaciones.formatRut(rut, {
              showDots: true,
              showHyphen: true,
            }),
          },
        })
      );
    } else {
      const { jsonData } = store.getState().denuncias;
      dispatch(
        setDataNewComplain({
          ...jsonData,
          formDenunciante: {
            FirstName: null,
            cantEditFirstName: false,
            LastName: null,
            cantEditLastName: false,
            MothersName: null,
            cantEditMothersName: false,
            Rut: validaciones.formatRut(rut, {
              showDots: true,
              showHyphen: true,
            }),
          },
        })
      );
    }
  } catch (e) {
    trace.error("goGetDenuncianteData", e);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error al obtener la info del usuario",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const doAutoCompleteTrabajadorInfo = (jsonData, companyRut) => async (
  dispatch
) => {
  dispatch(loading(true));
  try {
    const request = await GetValidacionTrabajadorEmpresa({
      CompanyRut: companyRut,
      // Fecha: Moment(jsonData.formInfoDenuncia.FechaPresentacion).format("DD/MM/YYYY"),
      Rut: jsonData.formInfoDenuncia.rutTxt,
      idTipoDenuncia: jsonData.formInfoDenuncia.tipoDenuncia.IdTipoDenuncia,
    });
    if (request.status === 200) {
      const result = await request.json();
      const form = { ...jsonData };

      const fechaNacimiento =
        result.ListaValidationsEmployeeCompany[0].fechaNacimiento !== ""
          ? result.ListaValidationsEmployeeCompany[0].fechaNacimiento
          : null;
      const nombre =
        result.ListaValidationsEmployeeCompany[0].nombres !== ""
          ? result.ListaValidationsEmployeeCompany[0].nombres
          : null;
      const apellidoPaterno =
        result.ListaValidationsEmployeeCompany[0].apellidoPaterno !== ""
          ? result.ListaValidationsEmployeeCompany[0].apellidoPaterno
          : null;
      const apellidoMaterno =
        result.ListaValidationsEmployeeCompany[0].apellidoMaterno !== ""
          ? result.ListaValidationsEmployeeCompany[0].apellidoMaterno
          : null;

      const dataTrabajador = {
        Rut: validaciones.formatRut(jsonData.formInfoDenuncia.rutTxt, {
          showDots: true,
          showHyphen: true,
        }),
        FirstName: nombre,
        LastName: apellidoPaterno,
        MothersName: apellidoMaterno,
        Birthdate: fechaNacimiento
          ? Moment(fechaNacimiento, "DD/mm/YYYY")
          : null,
        Sexo: {
          Codigo: result.ListaValidationsEmployeeCompany[0].sexo
            ? result.ListaValidationsEmployeeCompany[0].sexo.idSexo
            : null,
          Sexo: result.ListaValidationsEmployeeCompany[0].sexo
            ? result.ListaValidationsEmployeeCompany[0].sexo.descripcionSexo
            : null,
        },
        Nacionalidad: {
          Codigo: result.ListaValidationsEmployeeCompany[0].nacionalidad
            ? result.ListaValidationsEmployeeCompany[0].nacionalidad
                .idNacionalidad
            : null,
          Nacionalidad: result.ListaValidationsEmployeeCompany[0].nacionalidad
            ? result.ListaValidationsEmployeeCompany[0].nacionalidad
                .descripcionNacionalidad
            : null,
        },
      };
      form.formInfoTrabajador = {
        ...dataTrabajador,
        ...jsonData.formInfoTrabajador,
      };
      dispatch(setDataTrabajador(dataTrabajador));
      dispatch(setDataNewComplain(form));
      dispatch(setStep(2));
      dispatch(setShowHideForm(true));
    }
  } catch (e) {
    console.error("doAutoCompleteTrabajadorInfo", e);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};
